import { IRouteOfStore } from './store'

export enum EChannelsSwitcherCategory {
  QR = 'qr',
  Card = 'card',
}

export interface IChannelMap {
  [key: string]: IRouteOfStore | null
}
